import { useRouter } from "next/router";

import { Button } from "ui/Button";
import { useI18n } from "utils/with-i18n.utils";

import CheckBadge from "./check-badge.svg";

type ValidatedContentProps = {
  isComingSoon?: boolean;
};

export const ValidatedContent = ({
  isComingSoon = false,
}: ValidatedContentProps) => {
  const i18n = useI18n();
  const { push } = useRouter();

  return (
    <>
      <CheckBadge className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2" />
      <div className="flex flex-col gap-4 justify-center items-center mt-12 text-center">
        <p className="text-3xl font-semibold">
          {i18n.t("product.reminder.beWarned")}
        </p>
        <p className="text-gray">
          {i18n.t(
            isComingSoon
              ? "product.comingSoon.beWarned.explanation"
              : "product.outOfStock.beWarned.explanation",
          )}
        </p>
        <Button type="button" onClick={() => push("/")}>
          {i18n.t("product.outOfStock.backHome")}
        </Button>
      </div>
    </>
  );
};
